import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import Loader from '../../../../components/Loader/Loader';
import CustomBtn from '../../../../generic/CustomBtn/CustomBtn';
import { getJSONFileFromIpfs, initIPFS } from '../../../../state/ipfs';

const SampleTree = ({
  treeName,
  status,
  height,
  diameter,
  treePhoto,
  labelPhoto,
}) => {
  const [previewImg, setPreviewImg] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const translate = useIntl();

  const noData = '';
  const nameSlice = (fileName) => `${fileName.slice(0, 15)}...${fileName.slice(fileName.length - 5, fileName.length)}`;

  const showPreviewPhoto = async (photoCid) => {
    if (photoCid) {
      setShowPreview(true);

      const ipfs = await initIPFS();

      let ipfsPhoto = await getJSONFileFromIpfs(ipfs, photoCid);
      ipfsPhoto = JSON.parse(ipfsPhoto);

      const base64Photo = ipfsPhoto.data.includes('data:') ? ipfsPhoto.data : `data:${ipfsPhoto.mime};base64,${ipfsPhoto.data}`;
      setPreviewImg(base64Photo);
    }
  };
  return (
    <>
      <div className="tree-item upload-preview_item">
        <div className="tree-name">
          <span className="upload-preview_value upload-preview_name">
            {treeName || noData}
          </span>
        </div>
        <div className="tree-status">
          <span className="upload-preview_value upload-preview_status">
            {status ? status[0].toUpperCase() + status.substring(1) : noData}
          </span>
        </div>
        <div className="tree-height">
          <span className="upload-preview_value upload-preview_size">
            {height || noData}
          </span>
        </div>
        <div className="tree-diameter">
          <span className="upload-preview_value upload-preview_size">
            {diameter || noData}
          </span>
        </div>
        <div className="tree-photo" onClick={() => showPreviewPhoto(treePhoto)}>
          <span className="upload-preview_value upload-preview_photo">
            {treePhoto ? nameSlice(treePhoto) : noData}
          </span>
        </div>
        <div className="tree-label" onClick={() => showPreviewPhoto(labelPhoto)}>
          <span className="upload-preview_value upload-preview_photo">
            {labelPhoto ? nameSlice(labelPhoto) : noData}
          </span>
        </div>
        {showPreview && (
        <div className="photo__preview">
          <div className="photo__preview-background" />
          {previewImg ? (
            <img src={previewImg} alt="alt" />
          ) : (
            <Loader customClass="lds-ring__small" />
          )}
          <CustomBtn
            label={translate.formatMessage({ id: 'button-close' })}
            iconClass="icon-close"
            customClass="btn__cancel"
            handleClick={() => {
              setShowPreview(false);
              setPreviewImg();
            }}
          />
        </div>
        )}
      </div>
    </>
  );
};
export default SampleTree;
